import React from 'react';
import cls from 'classnames';
import { useMsg } from '@/hooks/useUnreadMsg';

import styles from './index.less';

const MenuLabel = (props: any) => {
  const { label, field } = props;
  const [msgCount] = useMsg();

  const classNames = cls({
    [styles.menuLabel]: true,
    [styles.remind]: msgCount[field] && msgCount[field] > 0,
  });
  return (
    <div className={classNames}>
      { label }
    </div>
  );
};

export default MenuLabel;
